export const GET_ALL_PROJECTS_REQUEST = " GET_ALL_PROJECTS_REQUEST";
export const GET_ALL_PROJECTS_SUCCESS = " GET_ALL_PROJECTS_SUCCESS";
export const GET_ALL_PROJECTS_FAILURE = " GET_ALL_PROJECTS_FAILURE";
